import StSystemNavigationDrawer from '@/language/en/StSystemNavigationDrawer';
import StCompanySelection from '@/language/en/StCompanySelection';
import LoginView from '@/language/en/LoginView';
import ErrorStatus from '@/language/en/ErrorStatus';
import DataManagement from '@/language/en/DataManagement';
import views from '@/language/en/views';
import components from '@/language/en/components';
import mixins from '@/language/en/mixins';
import BrandHealth from '@/language/en/BrandHealth';
import stocks from '@/language/en/stocks';
import DistributionMediaPieChart from '@/language/en/DistributionMediaPieChart';
import library from '@/language/en/library';
import utils from '@/language/en/utils';

export default {
  systemName: 'Dash',
  StSystemNavigationDrawer,
  StCompanySelection,
  LoginView,
  ErrorStatus,
  DataManagement,
  views,
  components,
  mixins,
  BrandHealth,
  stocks,
  DistributionMediaPieChart,
  library,
  utils,
};
